<script>
  export let mode
  export let label
  export let setMode
  export let flex = false
  $: active = label == mode
</script>

<div class='div-50' class:flex class:active on:click={() => setMode(label)}>
  <div>
    <slot />
  </div>
</div>

<style>

</style>
